import { Link } from 'react-router-dom';
import DonateSection from './DonateSection';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="footer-heart">💜</span>
          <span className="footer-title">Special and Beyond</span>
          <p className="footer-tagline">
            Made with love by Emmi, for her sister Izzi 🌟<br />
            Learning to understand, include, and celebrate every child.
          </p>
        </div>

        <div className="footer-links">
          <h4>Pages</h4>
          <ul>
            <li><Link to="/">🏠 Home</Link></li>
            <li><Link to="/about">👧 Our Story</Link></li>
            <li><Link to="/learn">📚 Learn</Link></li>
            <li><Link to="/events">📅 Events</Link></li>
            <li><Link to="/forum">💬 Share Your Story</Link></li>
          </ul>
        </div>

        <div className="footer-message">
          <h4>A note from Emmi 💌</h4>
          <p>
            "Every kid is special in their own way. My sister Izzi might do
            things differently, but she makes the world a brighter place.
            I hope this website helps you see that too!"
          </p>
          <p className="footer-hearts">💜 🌿 🍑 💙 ⭐</p>
        </div>
      </div>

      <div className="footer-donate container">
        <DonateSection compact />
      </div>

      <div className="footer-bottom">
        <p>© 2024 Special and Beyond — Made with 💜 by Emmi</p>
      </div>
    </footer>
  );
}
